import React, { useReducer, useEffect, useState } from 'react';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { Button } from '@material-ui/core';
import { saveOrUpdateGlobalMmrConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import { useDispatch, useSelector } from 'react-redux';
import { formDataValidate } from '../../../utils/formUtils';
import {
  fetchAllGREGlobalConfigs,
  greGlobalMMRTabSelector,
  vendorsSelector,
} from '../../../layouts/configurations/configurationSlice';
import CustomSelect from '../../../shared/form-controls/custom-select/Custom-Select';
import CustomMultiSelect from '../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import { GRE_LIST, GRE_MULTI_LIST } from '../../../constants/restaurantConst';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceGlobalTabMMR = (props) => {
  const { showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const allVendors = useSelector(vendorsSelector);
  const { MMR } = allVendors;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'MMR Code',
      errors: {},
      validations: [],
    },
    provider: {
      value: '',
      fieldName: 'MMR Provider',
      errors: {},
      validations: [],
    },
    protocol: {
      value: '',
      fieldName: 'MMR Protocol',
      errors: {},
      validations: [],
    },
    id: {
      value: '',
      fieldName: 'ID',
      errors: {},
      validations: ['required'],
    },
  });
  const data = useSelector(greGlobalMMRTabSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      setIsTabInValid(false);
      const currFields = { ...formData };
      for (let field in data) {
        if (currFields.hasOwnProperty(field)) {
          currFields[field].value = data[field];
        }
      }
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        const payload = {};

        for (let field in formData) {
          payload[field] = formData[field].value;
        }

        await saveOrUpdateGlobalMmrConfigs(selectedHotel, payload);
        notificationManager('success', 'MMR details saved successfully');
        dispatch(fetchAllGREGlobalConfigs(selectedHotel));
      } catch (error) {
        if (error?.message) {
          notificationManager('danger', error?.message);
        } else {
          notificationManager('danger', 'MMR details save failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(Object.entries(formData));
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form className='global-tab' noValidate onSubmit={handleSubmit}>
      <div className='container px-0 d-flex align-items-end flex-column h-100'>
        <div className='row w-100 d-flex mt-2'>
          <div className='col- 12 d-flex flex-wrap row'>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
              />
            </div>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomSelect
                item={formData.provider}
                handleInputChange={(e) => {
                  setFormData({ provider: e });
                }}
                options={MMR}
                labelField='name'
                valueField='id'
              />
            </div>
          </div>
          <div className='col-12 d-flex flex-wrap row'>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomMultiSelect
                item={formData.protocol}
                handleInputChange={(e) => {
                  setFormData({ protocol: e });
                }}
                options={GRE_MULTI_LIST}
                labelField='name'
                valueField='id'
              />
            </div>
            <div className='col-12 col-lg-6 mb-3'>
              <CustomTextField
                item={formData.id}
                handleInputChange={(e) => {
                  setFormData({ id: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row d-flex mt-auto w-100 pb-4'>
          <div>
            <Button
              size='large'
              variant='contained'
              color='primary'
              className='me-3'
              type='submit'
              disabled={isTabInValid}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceGlobalTabMMR;
